export class AuditLogsRequest {
    public action: string;
    public timePeriod: string;
    public date: string;
    constructor() {}
}
